export default __webpack_public_path__ + "static/media/do2meProfessional.3687ee7f.gif";